import { resolveTaskId } from './resolveTaskOccurrence';
import request from "../../app/api/requests";
import { activateTimer } from "../lib/store/RunTimeTaskResults/RunTimeResults";

export const timerPush = payload => async dispatch => {
    const databaseId = await resolveTaskId(payload.taskId);
    const response = await request.put('/Timer', {
        taskId: databaseId,
        userId: localStorage.getItem('userID'),
        timerTime: payload.startTime,
        timerIsActive: payload.timerIsActive,
    });
    dispatch(activateTimer({taskId: payload.taskId, isTimerActive: payload.timerIsActive,
        startTime: payload.timerIsActive ? payload.startTime : null}));
    return response.data;
};
